import React from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";
import dayjs from "dayjs";
import { STATUS_CONFIG } from "./statusConfig";

/**
 * ApplicationListItem — displays a single insurance application entry
 * with reference number, color-coded status badge, and formatted dates.
 *
 * Requirements: 3.1, 3.2, 3.3, 3.4, 3.5
 */
export default function ApplicationListItem({
  referenceNumber,
  status,
  submittedAt,
  insuranceStartDate,
}) {
  const statusConfig = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <div
      style={{
        padding: "12px 16px",
        borderBottom: "1px solid #f0f0f0",
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: 600, fontSize: 16 }}>{referenceNumber}</span>
        <Tag color={statusConfig.color}>{statusConfig.label}</Tag>
      </div>

      <div style={{ color: "#757575", fontSize: 13 }}>
        <div>
          วันที่สมัคร:{" "}
          {dayjs(submittedAt).format("DD/MM/YYYY")}
        </div>
        {insuranceStartDate && (
          <div>
            วันเริ่มคุ้มครอง:{" "}
            {dayjs(insuranceStartDate).format("DD/MM/YYYY")}
          </div>
        )}
      </div>
    </div>
  );
}

ApplicationListItem.propTypes = {
  referenceNumber: PropTypes.string.isRequired,
  status: PropTypes.oneOf([
    "waiting_for_payment",
    "pending",
    "completed",
    "rejected",
  ]).isRequired,
  submittedAt: PropTypes.string.isRequired,
  insuranceStartDate: PropTypes.string,
};
